<template>
  <ExActionsPopUp
    :value="show"
    headline="Unarchive Checkpoint"
    :icon="'org_icon_checkpoint'"
    :htmlInfo="info"
    :destructive="false"
    actionLabel="Unarchive"
    :centerHeadline="true"
    actionsTopSpacing="32px"
    @onAction="handleUnarchive"
    @input="$emit('onClose')"
    data-testid="unarchive-checkpoint-popup"
    :applyBorderClass="true"
    :width="500"
    :archiveModel="true"
    :label="'Checkpoint Name*'"
    :placeholder="'Place Holder'"
    :archiveInputInitialValue="name"
    :isShowCharCounter="true"
    :orgObjectType="'Checkpoint'"
  >
  </ExActionsPopUp>
</template>
<script setup>
import { computed } from "vue";
import ExActionsPopUp from "@components/common/ExActionsPopUp.vue";

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
  name: {
    type: String,
    default: "",
  },
});

const emit = defineEmits(["onUnarchive", "onClose"]);

const formattedInfo = computed(() => {
  return `<div style="max-width: 260px; margin: 0 auto; margin-top: 26px;">You are about to unarchive checkpoint ${props.name}.</div>`;
});

const info = computed(() => {
  return formattedInfo.value;
});

const handleUnarchive = (updatedName) => {
  emit("onUnarchive", updatedName);
};
</script>

